/**
 * EstadoOrdenBadge - Badge con colores semánticos por estado de orden.
 */

import { StatusBadge, type StatusBadgeClasses } from "./status-badge";

const ESTADO_ORDEN_CLASSES: Record<string, StatusBadgeClasses> = {
  PENDIENTE: {
    pill: "bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-200",
    dot: "bg-gray-700 dark:bg-gray-200",
  },
  EN_EXTRACCION: {
    pill: "bg-amber-100 text-amber-800 dark:bg-amber-900/60 dark:text-amber-200",
    dot: "bg-amber-800 dark:bg-amber-200",
  },
  CON_RESULTADO: {
    pill: "bg-sky-100 text-sky-800 dark:bg-sky-900/60 dark:text-sky-200",
    dot: "bg-sky-800 dark:bg-sky-200",
  },
  FINALIZADA: {
    pill: "bg-green-100 text-green-800 dark:bg-green-900/60 dark:text-green-200",
    dot: "bg-green-800 dark:bg-green-200",
  },
  BAJA: {
    pill: "bg-red-100 text-red-800 dark:bg-red-900/60 dark:text-red-200",
    dot: "bg-red-800 dark:bg-red-200",
  },
};

const FALLBACK: StatusBadgeClasses = {
  pill: "bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-200",
  dot: "bg-gray-700 dark:bg-gray-200",
};

interface EstadoOrdenBadgeProps {
  estado: string;
  label: string;
  className?: string;
}

export function EstadoOrdenBadge({ estado, label, className }: EstadoOrdenBadgeProps) {
  return (
    <StatusBadge
      label={label}
      classes={ESTADO_ORDEN_CLASSES[estado] ?? FALLBACK}
      className={className}
    />
  );
}
